import React from 'react';
import StyledButton from '../../Shared/StyledButton/StyledButton';
import './Styles/Banner.scss';

const Banner=()=>{
    return(
        <div className="why-banner">
 <div className="content">
 <h1>Everything you need to bring ideas to life</h1>
<p>With the Hostdesign platform, access all the core functionality you need to build digital - eireframe, prototype and generate design specs in one place</p>
 </div>
 <div className="btns">
     <StyledButton btn="Sign up for free" />
     <StyledButton styles="nobg-btn" btn="Pricing plan" />
 </div>
        </div>
    )
};
export default Banner ;